<template>
    <div>
        <div class="row pl-3 pr-1 data-row mx-0" :style="rowDetail ? 'border-bottom: none' : ''">
            <div class="px-1 col-2">
                <basic-info></basic-info>
            </div>
            <div class="px-1 col-2">
                <small
                    >{{ target.data.success }} %
                    <i
                        v-if="target.data.hasOwnProperty('results')"
                        class="cursor-pointer text-primary fa fa-lg fa-caret-right"
                        :class="{ 'rot-90': rowDetail }"
                        @click="rowDetail = !rowDetail"
                    ></i
                ></small>
            </div>
            <div class="px-1 col-7">
                <small
                    ><span v-if="isBaseline" class="font-weight-bold text-uppercase text-primary"
                        >Baseline</span
                    >
                    {{ target.notes ? target.notes : "none" }}</small
                >
            </div>
            <div class="px-1 col-1">
                <data-actions
                    @delete-tracker="$emit('delete-tracker')"
                    @edit-target="$emit('edit-target', $event)"
                    @close-details="$emit('close-details')"
                ></data-actions>
            </div>
        </div>
        <div class="row pl-3 pr-1 data-row mx-0" v-if="rowDetail" style="border-top:none;">
            <div class="px-1 col-2 offset-2">
                <div class="d-flex" v-for="(r, i) in target.data.detailed_results">
                    <span class="text-nowrap mr-2 small"
                        >{{ i + 1 }}. {{ r ? r.split(":")[0] : "" }}</span
                    >
                    <prompt
                        v-if="
                            r &&
                                r.split(':').length > 1 &&
                                r.split(':')[1] &&
                                r.split(':')[1].trim() &&
                                !isNaN(parseInt(r.split(':')[1].trim()))
                        "
                        :mini="true"
                        :prompt="[null, iconset, parseInt(r ? r.split(':')[1].trim() : 0)]"
                    ></prompt>
                    <span v-else="" class="small">[No data]</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Prompt from "../../ui/PromptIcon";
import BasicInfo from "./BasicInfo";
import DataActions from "./DataActions";

export default {
    name: "TrackerDataArticulation",
    inject: ["target", "isBaseline", "iconset"],
    data() {
        return {
            rowDetail: false,
        };
    },
    components: {
        Prompt,
        BasicInfo,
        DataActions,
    },
};
</script>
